import { Pipe, Inject, LOCALE_ID } from '@angular/core';
import { ConfigService } from '../../providers/config/config.service';
import { AbstractConfigurableDatePipe } from './AbstractConfigurableDatePipe';

@Pipe({name: 'configurableDate'})
export class ConfigurableDatePipe extends AbstractConfigurableDatePipe {

    private format: string;

    constructor(@Inject(LOCALE_ID) locale: string,
        private configService: ConfigService) {
        super(locale);
        if (configService) {
            this.format = configService.getDisplayDateFormat();
        }
    }

    protected getFormat(): string {
        return this.format;
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/ConfigurableDatePipe.ts